import angular from 'angular';
import { ApiProvider } from './ApiProvider';
import { ApiInterceptor } from './ApiInterceptor';

angular
	.module('sh.api', [])
	.provider('Api', ApiProvider)
	.factory('ApiInterceptor', ApiInterceptor)
	.config(function ($httpProvider) {
		'ngInject';
		$httpProvider.interceptors.push('ApiInterceptor');
	});
